import { useAuth } from '../contexts/AuthContext';
import { isSuperadminOnly, isDefaultGranted, userHasAnyMenuIn, RbacUser } from './menuHelpers';

export function useMenu(menuKey: string): boolean {
  const { user } = useAuth() as { user: RbacUser | null };
  if (!user) return false;
  if (user.superadmin) return true;

  // Module-level check: 'module:scouting' → userHasAnyMenuIn(user, 'scouting')
  if (menuKey.startsWith('module:')) {
    return userHasAnyMenuIn(user, menuKey.slice('module:'.length));
  }

  if (isSuperadminOnly(menuKey)) return false;
  if (isDefaultGranted(menuKey)) return Boolean(user.role) || false;
  if (user.role?.isFarmAdministrator) return true;
  return Boolean(user.role?.menus?.includes(menuKey));
}
